var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55059 3.63335C1.55059 2.83008 2.43948 2.32804 3.15059 2.72967L11.9506 7.6999C12.6617 8.10154 12.6617 9.10563 11.9506 9.50726L3.15059 14.4775C2.43948 14.8791 1.55059 14.3771 1.55059 13.5738L1.55059 3.63335Z",
    fill: "#B08C3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.52148 22.9566C1.52148 22.3803 1.98867 21.9131 2.56496 21.9131L22.9128 21.9131C23.4891 21.9131 23.9563 22.3803 23.9563 22.9566C23.9563 23.5329 23.4891 24 22.9128 24L2.56496 24C1.98867 24 1.52148 23.5329 1.52148 22.9566Z",
    fill: "#B08C3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.82617 16.6948C8.82617 16.1185 9.29335 15.6514 9.86965 15.6514L22.9131 15.6514C23.4894 15.6514 23.9566 16.1185 23.9566 16.6948C23.9566 17.2711 23.4894 17.7383 22.9131 17.7383L9.86965 17.7383C9.29335 17.7383 8.82617 17.2711 8.82617 16.6948Z",
    fill: "#B08C3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1738 10.4341C17.1738 9.85781 17.641 9.39062 18.2173 9.39062H22.913C23.4893 9.39062 23.9564 9.85781 23.9564 10.4341C23.9564 11.0104 23.4893 11.4776 22.913 11.4776H18.2173C17.641 11.4776 17.1738 11.0104 17.1738 10.4341Z",
    fill: "#B08C3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramIcon);
export default __webpack_public_path__ + "static/media/program-icon.de66aa7a2e1456ed422c4dc648ecf53e.svg";
export { ForwardRef as ReactComponent };